(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.controller
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [frontend.ui.component.lp-portal.report.company.net-debt-chart.controller :as net-debt-controller]
   [frontend.ui.component.lp-portal.report.company.overview.controller :as company-overview]
   [frontend.ui.component.lp-portal.report.company.value-chart.controller :as valuation-controller]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.style.theme.core :as theme]))

(defn config->editable-data
  [config]
  {:chart-key :distribution-yield
   :columns (some->> config
                     :xAxis
                     (mapcat :categories)
                     (vec))
   :data    (->> config
                 :series
                 (mapv (fn [serie]
                         (vec (concat [(:name serie)]
                                      (:data serie))))))
   :y-axis-config (chart-utils/config->editable-y-axis-data config)
   :tooltip-config (chart-utils/config->editable-tooltip-data config)})

(defn editable-data->raw-data
  [edited-data]
  (let [hardcoded-keys [:yield]]
    (merge {:labels (:columns edited-data)}
           {:series-names (mapv first (:data edited-data))}
           (->> edited-data
                :data
                (map-indexed (fn [idx row]
                               (let [number-data (->> row
                                                      rest
                                                      (filter (fn [row-item]
                                                                (or (nil? row-item)
                                                                    (number? row-item))))
                                                      vec)]
                                 (if-let [key (get hardcoded-keys idx)]
                                   [key number-data]
                                   (js/console.warn "Cannot resolve data " row)))))
                (into {})))))

(defn distribution-yield
  [{:keys [labels y-axis-config tooltip-config yield series-names]}]
  (let [y-axis-1 (chart-utils/resolve-editable-axis-data (first y-axis-config) chart-utils/axis-pct-formatter "")
        tooltip-1 (chart-utils/resolve-editable-tooltip-data (first tooltip-config) chart-utils/mult-to-pct-formatter)
        series-name-1 (chart-utils/resolve-series-name (first series-names) "Distribution Yield")]
  {:chart       {:zoomType "xy"}
   :xAxis       [{:categories    labels
                  :lineColor     (theme/color [:chart :x-axis :line])
                  :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
   :yAxis       [{:title         {:text (:title-text y-axis-1)}
                  :labels        {:formatter     (:formatter-fn y-axis-1)}
                  :lineColor     (theme/color [:chart :y-axis :line])
                  :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
   :colors      [(theme/color [:chart :line-chart :line])]
   :tooltip     {:outside         true
                 :useHtml         true
                 :backgroundColor (theme/color [:page-bg :bg])
                 :style           {:opacity         1
                                   :backgroundColor (theme/color [:page-bg :bg])}

                 :shared          true}
   :plotOptions {:line {:marker {:enabled false}}}
   :series      [{:name    series-name-1
                  :type    "column"
                  :data    yield
                  :tooltip {:outside         true
                            :useHtml         true
                            :backgroundColor (theme/color [:page-bg :bg])
                            :style           {:opacity         1
                                              :backgroundColor (theme/color [:page-bg :bg])}
                            :pointFormatter  (:formatter-fn tooltip-1)}}]}))

(defn ->ui-data
  [{:keys [report-data] :as props}]
  {:holding-name       (get-in report-data [:holding-name])
   :reference-date     (get-in report-data [:reference-date])
   :report-id          (:report-id props)
   :overview           {:case-overview-text (report-ctl/rich-content
                                             props
                                             :case-overview-text)
                        :market-development-text (report-ctl/rich-content
                                                  props
                                                  :market-development-text)
                        :latest-development-text (report-ctl/rich-content
                                                  props
                                                  :latest-development-text)
                        :overview-figures (report-ctl/with-footnote
                                           props
                                           :overview-figures-footnotes
                                           (company-overview/overview-figures (get-in report-data
                                                                     [:basic-equity])))
                        :board (report-ctl/with-footnote
                                props
                                :board-footnotes
                                (company-overview/overview-figures-board (get-in report-data
                                                                                 [:basic-equity])))}
   :financial-performance-text (report-ctl/rich-content
                                props
                                :financial-performance-text)
   :financials         (->>
                         (get-in report-data [:financials])
                         (report-ctl/with-footnote props :financials-footnotes)
                         (report-ctl/with-editable-charts
                          props
                          :financials
                          financials-controller/company-financials
                          financials-controller/config->editable-data
                          financials-controller/editable-data->raw-data))
   :net-debt           (->>
                         (get-in report-data [:net-debt])
                         (report-ctl/with-footnote props :net-debt-footnotes)
                         (report-ctl/with-editable-charts
                          props
                          :net-debt
                          net-debt-controller/company-net-debt
                          net-debt-controller/config->editable-data
                          net-debt-controller/editable-data->raw-data))
   :value-creation-plan-text (report-ctl/rich-content
                              props
                              :value-creation-plan-text)
   :optional-section   (report-ctl/optional-rich-content props
                                                         :optional-section-heading
                                                         :optional-section-text)
   :valuation-text     (report-ctl/rich-content
                        props
                        :valuation-text)
   :valuation          (->>
                         (get-in report-data [:valuation])
                         (report-ctl/with-footnote props :valuation-footnotes)
                         (report-ctl/with-editable-charts
                          props
                          :valuation
                          valuation-controller/company-valuation
                          valuation-controller/config->editable-data
                          valuation-controller/editable-data->raw-data))
   :distribution-yield (->>
                         (get-in report-data [:financials])
                         (report-ctl/with-footnote props :distribution-yield-footnotes)
                         (report-ctl/with-editable-charts
                          props
                          :distribution-yield
                          distribution-yield
                          config->editable-data
                          editable-data->raw-data))
   :ownership          (report-ctl/with-footnote
                        props
                        :ownership-footnotes
                        (get-in report-data [:ownership]))})
